<template>
  <div class="item-position trend-common">
    <div>漏电</div>
    <div id="leakage"/>
  </div>
</template>

<script>
import G2 from '@antv/g2'
export default {
  name: 'LeakageGrid',
  data () {
    return {
      chart: null
    }
  },
  props: {
    data: {
      type: Array
    }
  },
  watch: {
    data (val, oldVal) {
      if (val !== oldVal) {
        this.chart.source(val)
        this.chart.repaint()
      }
    }
  },
  methods: {
    initChart () {
      this.chart = new G2.Chart({
        container: 'leakage',
        width: 300,
        height: 210,
        padding: [ 10, 20, 70, 40 ]
      })
      this.chart.tooltip({
        crosshairs: {
          type: 'line'
        }
      })
      this.chart.axis('time', {
        label: null,
        line: {
          stroke: '#545454'
        },
        tickLine: {
          stroke: '#545454'
        }
      })
      this.chart.axis('value', {
        grid: null
      })
      this.chart.tooltip({
        'g2-tooltip': {
          border: '1px solid rgb(73, 213, 243)',
          backgroundColor: ' rgba(0, 0, 0, 0.8)',
          color: 'rgb(255, 255, 255)',
          boxShadow: 'rgb(73, 213, 243) 0px 0px 3px'
        }
      })
      this.chart
        .line()
        .position('time*value')
        .color('name')
        .shape('smooth')
        .tooltip('name*value', (name, value) => {
          return {
            name: name,
            value: value.toFixed(0) + 'mA'
          }
        })
      this.chart.source(this.data, {
        time: {
          // 设置日期类型
          type: 'time',
          mask: 'YYYY-MM-DD HH:MM:ss'
        }
      })
      this.chart.render()
    }
  },
  mounted () {
    this.initChart()
  }
}
</script>

<style scoped lang="scss">
  .trend-common {
    display: flex;
    align-items: center;
    left: 1610px;
    top: 870px;
    div:first-child{
      width: 20px;
      color: #abacad;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LeakageGrid.vue